<script setup lang="ts">
import { type PropType } from 'vue'

interface Info {
  title: string
  description: string
  eyebrow: string
  imagePath: string
}

const props = defineProps({
  data: {
    type: Object as PropType<Info>,
  },
})
</script>

<template>
  <div v-if="props.data" class="relative mt-80">
    <div
      :class="[
        'absolute ',
        'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform',
        'bg-primary-background xs:h-[80rem] xs:w-screen xl:h-[60rem] xl:w-[100rem]',
        '-z-10 rounded-3xl',
      ]"
    />
    <div class="xs:flex-col flex items-center justify-between gap-24 md:flex-col xl:flex-row">
      <div class="z-20">
        <h5 class="text-primary-darkish xs:mt-12 z-30 flex items-center text-sm font-bold uppercase md:mt-6 xl:mt-6">
          {{ props.data?.eyebrow }}
        </h5>
        <div class="xs:text-justify lg:text-left">
          <div class="md:w-2/4 lg:w-3/5">
            <WComponentTitle class="my-3">{{ props.data?.title }} </WComponentTitle>
          </div>
          <WParagraph>{{ props.data?.description }} </WParagraph>
        </div>
      </div>
      <div class="z-20">
        <img :src="`/services/${props.data?.imagePath}`" class="lg:h-full xl:w-[160rem]" alt="" />
      </div>
    </div>
  </div>
</template>
